<template>
    <div class="d-flex flex-column col-12 p-0">
        <p v-if="filteredCharges.length > 0" class="fs-5">Select individual charges by clicking the checkboxes or select
            them all with the “Select All” button.</p>
        <p v-if="filteredCharges.length > 0" class="fs-5 mb-3"> You can then change the status and/or concurrency, or
            delete the selected charges. </p>
        <!-- <h1 class="section-header py-3 px-5 fw-bold">Update Multiple Charges</h1> -->
        <!-- <Modal>
        
        <template v-slot:header>
            <div class="d-flex justify-content-between w-100 align-items-center ">
                <div></div>
                <h4 class="fs-3 fw-bold">Update Multiple Charges</h4>
                <button class="btn btn-gray btn-xl" @click="$emit('close')">
                    <i class="fa fa-close"></i>
                </button>
            </div>
        </template>
<template v-slot:body> -->
        <Modal size="medium" v-show="showDeleteAllModal">
            <template v-slot:header>
                <div class="d-flex justify-content-between w-100 align-items-center ">
                    <div></div>
                    <h4 class="fs-3 fw-bold ml-5 mr-5">Delete All Charges</h4>
                    <button class="btn btn-gray btn-xl" @click="showDeleteAllModal = false">
                        <i class="fa fa-close"></i>
                    </button>
                </div>
            </template>
            <template v-slot:body>
                <div class="p-5 d-flex flex-column" v-if="selectedCharges.length > 0 && charges.length > 0">
                    <p class="fs-5 mb-3">Are you sure you want to delete these charges?</p>

                    <p class="fs-5" v-for="charge in selectedCharges" :key="charge.Id">
                        {{ charge.CountNumber }}. {{ charge.SectionNumber }}
                    </p>

                    <p class="fs-5 mt-3">Any enhancements attached to these charges will also be deleted.</p>
                    <div class="d-flex mt-3">

                        <loading-button style="height: 30px" class="mr-3" v-if="loading"></loading-button>
                        <button v-else class="btn btn-primary mr-3" @click="
                            showDeleteAllModal = false;
                        deleteSelectedCharges(selectedCharges);
                        ">
                            Delete Charges
                        </button>
                        <button class="btn btn-outline btn-xl" @click="
                            showDeleteAllModal = false;
                        ">
                            Cancel
                        </button>
                    </div>
                </div>
                <div class="p-5 d-flex flex-column" v-else>
                    <p class="fs-5 mb-3 ta-c">No charges selected.</p>
                    <div class="d-flex justify-content-center">

                        <loading-button style="height: 30px" v-if="loading"></loading-button>
                        <!-- <button v-else class="btn btn-primary" @click="
                            showDeleteAllModal = false;">
                            Ok
                        </button> -->

                    </div>
                </div>
            </template>
        </Modal>
        <!-- <p class="fs-5 pl-5">Select which charges to update and the change you wish to perform.</p> -->
        <div class="w-100" style="overflow: auto; max-height: 60vh">

            <table class="border-right border-bottom  border-left w-100" v-if="filteredCharges.length > 0">
                <thead>
                    <tr style="height: 58px;" class="border-bottom">
                        <th class="fs-5 ta-c">Select</th>
                        <th class="fs-5 ta-c">Count</th>
                        <!-- <th class="fs-5" style="width: 100px;">Count</th> -->
                        <th class="fs-5">Section</th>
                        <th class="fs-5">Description</th>
                        <th class="fs-5">Severity</th>
                        <th class="fs-5">Status</th>
                        <th class="fs-5">Concurrency</th>
                        <!-- <th class="ta-c fs-5" colspan="3">Selected Term</th>
                        <th class="fs-5">Prior Strikes</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr style="height: 58px;" @click="charge.IsSelected = !charge.IsSelected"
                        v-for="charge in filteredCharges" :key="charge.Id" class="selectable clickable"
                        :class="charge.IsSelected ? 'selected' : ''">
                        <td class="fs-5 ta-c"><input type="checkbox" v-model="charge.IsSelected"></td>
                        <td class="fs-5 ta-c">{{ charge.CountNumber }}</td>
                        <!-- <td class="pl-5">{{ charge.CountNumber }}</td> -->
                        <td class="fs-5">{{ showSectionNumber(charge) }}</td>
                        <td class="fs-5">{{ charge.Name }}</td>
                        <td class="fs-5">
                            <span v-if="charge.CrimeTypeId == 5">
                                {{ ['Infraction', 'Misdemeanor', 'Felony'][charge.CrimeSeverityId - 1] }}
                            </span>
                        </td>
                        <td class="fs-5">{{ ['Convicted', 'Acquitted', 'Dismissed', 'Stayed 654', 'Stayed',
                            'Stayed'][charge.ChargeStatus] }}</td>
                        <td class="fs-5">{{ charge.newExposureObject?.concurrent ? 'Concurrent' : 'Consecutive' }}</td>
                        <!-- <td class="ta-c " style="width: 80px;" v-for="(term, index) in formatFormattedTriad(charge)"
                            :class="{
                                'fw-bold': index == charge?.SelectedTerm - 1 || formatFormattedTriad(charge).length == 1,
                                'border-left': index == 0,
                            }" :key="term" :colspan="3 / formatFormattedTriad(charge).length">{{ term }}

                        </td>
                        <td class="border-left">{{ charge.NumberOfStrikes == '2+!' ? '2+ Super' : charge.NumberOfStrikes
                            || '0'
                        }} {{ charge.NumberOfStrikes == '1' ? 'Strike' : 'Strikes' }}</td> -->
                    </tr>
                </tbody>
                <tfoot class="secondary-bg sticky-bottom border-left border-right">
                    <tr style="height: 58px;">
                        <td>
                            <button class="btn btn-primary-outline" style="width: 120px;" @click="selectAllCharges">{{
                                allSelected ? 'Uncheck All' : 'Select All' }}</button>
                        </td>
                        <td>

                        </td>
                        <!-- <td class="px-0">
                            
                            <div class="d-flex flex-column pl-5">
                                <i class="fa button-color clickable fa-arrow-up mb-2" @click="changeSelectedChargesCountNumbers(true)"></i>
                                <i class="fa button-color clickable fa-arrow-down" @click="changeSelectedChargesCountNumbers(false)"></i>
                            </div>

                        </td> -->
                        <td colspan="2">
                            
                        </td>
                        <td>

                            <!-- <select class="form-control" v-model="wobbleDirection">
                                    <option :value="null">Wobble</option>
                                    <option :value="1">Up</option>
                                    <option :value="2">Down</option>
                                </select> -->
                        </td>
                        <td>
                            <select class="form-control"  v-model="status">
                                <option disabled :value="null">Set Status</option>
                                <option :value="0">Convicted</option>
                                <option :value="1">Acquitted</option>
                                <option :value="2">Dismissed</option>
                                <option :value="3">Stayed (PC 654)</option>
                                <option :value="4">Stayed</option>
                                <!-- <option :value="5"></option> -->
                            </select>
                        </td>
                        <td>
                            <select class="form-control" 
                                v-model="concurrency">
                                <option disabled :value="null">Set Concurrency</option>
                                <option :value="false">Consecutive</option>
                                <option :value="true">Concurrent</option>
                            </select>
                        </td>

                        <!-- <td colspan="3" class="ta-c">
                            <select class="form-control" @change="updateAllSelectedCharges('term')" v-model="selectedTerm">

                                <option disabled :value="null">Set Term</option>
                                <option :value="1">Lower</option>
                                <option :value="2">Middle</option>
                                <option :value="3">Upper</option>
                            </select>
                        </td>
                        <td>
                            <select class="form-control" @change="updateAllSelectedCharges('strikes')" v-model="numberOfStrikes">

                                <option disabled :value="''">Set Strikes</option>
                                <option :value="'0'">0</option>
                                <option :value="'1'">1</option>
                                <option :value="'2+'">2+ </option>
                                <option :value="'2+!'">2+ (Super Strike)</option>
                            </select>
                        </td> -->
                    </tr>
                </tfoot>
            </table>
            <p class="fs-5 p-5" v-else-if="charges.length > 0 && filteredCharges.length == 0">No charges to matching
                your filter
                were found in this case.</p>
            <p class="fs-5" v-else>Charges you add will appear here where you can apply changes to multiple charges
                at once.
            </p>
        </div>

        <!-- <div class="d-flex flex-column py-3 pl-5">
                <p class="fs-4 fw-bold">Filters</p>
                <div class="d-flex pr-3">
                    <div class="d-flex flex-column">
                        <label class="fw-bold">Severity</label>
                        <select class="form-control" v-model="filters.Severity">
                            <option :value="null">All</option>
                            <option :value="1">Infractions</option>
                            <option :value="2">Misdemeanors</option>
                            <option :value="3">Felonies</option>
                        </select>
                    </div>
                    <div class="d-flex flex-column pl-5">
                        <label class="fw-bold">Crime Type</label>
                        <select class="form-control" v-model="filters.CrimeType">
                            <option :value="null">All</option>
                            <option :value="1">Status Enhancements</option>
                            <option :value="2">Substitutions</option>
                            <option :value="3">Probation Limitations</option>
                            <option :value="5">Crimes</option>
                            <option :value="6">Conduct Enhancements</option>
                        </select>
                    </div>
                </div>
            </div> -->
        <!--<div class="d-flex py-3">
                 <div class="d-flex flex-column pr-3">
                    <label class="fw-bold">Set Charge Status</label>
                    
                </div>
                <div class="d-flex flex-column pr-3">
                    <label class="fw-bold ">Set Concurrency</label>
                   
                </div>
                <div class="d-flex flex-column pr-3">
                    <label class="fw-bold ">Selected Term</label>
                    
                </div>
                <div class="d-flex flex-column pr-3">
                    <label class="fw-bold ">Count Number</label>
                    <div class="d-flex">
                    </div>
                </div>
            </div> -->
        <div class="mt-3 w-100 d-flex justify-content-between">
            
            <button class="btn btn-primary-outline" v-if="charges.length > 0 && selectedCharges.length > 0" @click="showDeleteAllModal = !showDeleteAllModal">Delete Charges</button>
            <span style="min-height: 36px"></span>
            <span v-if="errorMessage" class="error ml-3">{{ errorMessage }}</span>
            <button class="btn btn-primary mr-3" @click="updateAllSelectedCharges(false)" v-if="somethingHasBeenChanged && !saving">Save Changes</button>
            <button class="btn btn-primary mr-3" v-if="saving"><i class="fa fa-check mr-3"></i>Saved</button>
        </div>
        <!-- </template>
    </Modal> -->
    </div>

</template>
<script>
import { set } from "lodash";
import Modal from "../../../components/utils/Modal.vue";
import SC from '../../../components/utils/sharedComponent.vue';
import axios from "axios";
export default {
    name: "UpdateMultipleCharges",
    props: ["charges", "caseId"],
    components: { Modal, SC },
    computed: {
        selectedCharges() {
            let charges = this.charges.filter(charge => charge.IsSelected == 1)
            // console.log(charges)
            return charges;
        },
        allSelected() {
            let allSelected = true;
            this.charges.forEach(charge => {
                allSelected = allSelected && charge.IsSelected;
            });
            return allSelected;
        },
        filteredCharges() {
            return this.charges.filter(charge => {
                if (this.filters.CrimeType) {
                    return charge.CrimeTypeId == this.filters.CrimeType;
                }
                if (this.filters.Severity) {
                    return charge.CrimeSeverityId == this.filters.Severity;
                }
                return true
            })
        },
        somethingHasBeenChanged() {
            if (this.concurrency != null || this.status != null) {
                return true
            }
        }
    },
    data() {
        return {
            status: null,
            concurrency: null,
            loading: false,
            showDeleteAllModal: false,
            selectedTerm: null,
            errorMessage: null,
            numberOfStrikes: '',
            filters: {
                CrimeType: null,
                Severity: null,
                ChargeStatus: null,
            },
            wobbleDirection: null,
            saving: false,
        };
    },
    methods: {
        async updateAllSelectedCharges(value) {
            const token = localStorage.getItem("user_token");
            this.loading = true;
            this.$nextTick(async () => {
                for (const chg of this.selectedCharges) {
                    if (chg.ChargeStatus != this.status && this.status !== null && (!value || value == 'status')) {
                        chg.ChargeStatus = this.status;
                        // console.log('status', chg.ChargeStatus)
                        await SC.postChargeField(token, chg.Id, "ChargeStatus", this.status);
                    };
                    if (chg.Concurrency != this.concurrency && this.concurrency !== null && (!value || value == 'concurrency')) {
                        chg.Concurrency = this.concurrency;
                        // console.log('concurrency', chg.Concurrency)
                        await SC.postChargeField(token, chg.Id, "Concurrency", this.concurrency);
                    }
                    // if (chg.SelectedTerm != this.selectedTerm && this.validateSelectedTerm(chg) && this.selectedTerm !== null && (!value || value == 'term')) {
                    //     chg.SelectedTerm = this.selectedTerm;
                    //     // console.log('SelectedTerm', chg.SelectedTerm)
                    //     await SC.postChargeField(token, chg.Id, "SelectedTerm", this.selectedTerm);
                    // }
                    // if (chg.NumberOfStrikes != this.numberOfStrikes && this.numberOfStrikes !== null && (!value || value == 'strikes')) {
                    //     chg.NumberOfStrikes = this.numberOfStrikes;
                    //     // console.log('NumberOfStrikes', chg.NumberOfStrikes)
                    //     await SC.postChargeField(token, chg.Id, "NumberOfStrikes", this.numberOfStrikes);
                    // }
                    // if (this.wobbleDirection != null && chg.WobbleDirection == this.wobbleDirection ) {
                    //     this.wobbleCharge(chg, this.wobbleDirection);
                    // }
                };
                if (this.concurrency !== null && this.concurrency == true && 
                    this.selectedCharges.filter(c => c.CrimeTypeId == 5).length == 
                    this.charges.filter(c => c.CrimeTypeId == 5).length
                ) {
                    this.showErrorMessage('Concurrency cannot be set to true for all charges.')
                }
                this.$emit('onCalc')
                this.loading = false;
                this.saving = true;
                this.charges.forEach(chg => {
                    chg.IsSelected = false;
                })
                this.concurrency = null;
                this.status = null;
                setTimeout(() => {
                    this.saving = false;
                }, 3000);
            })

        },
        selectAllCharges() {
            const direction = this.allSelected ? false : true;
            // console.log(direction);
            this.filteredCharges.forEach(charge => {
                charge.IsSelected = direction;
            });
        },
        async deleteSelectedCharges(charges) {
            // console.log(charges);
            const sortedCharges = charges.toSorted((a, b) => {
                // Sort by CrimeTypeId, where charges with CrimeTypeId == 6/2 are first, then 5, then 1 and 3
                let crimeTypeA = a.CrimeTypeId;
                let crimeTypeB = b.CrimeTypeId;
                if (crimeTypeA == 2) {
                    crimeTypeA = 7;
                }
                if (crimeTypeB == 2) {
                    crimeTypeB = 7;
                }
                return crimeTypeB - crimeTypeA;
            })

            for (const chg of sortedCharges) {
                const deletedCharge = await axios
                    .delete(process.env.VUE_APP_ENDPOINT + "/api/charges/" + chg.Id, {
                        headers: { Authorization: `Bearer ` + localStorage.getItem("user_token") },
                    })
                    .then((charges1) => {


                        return true;
                    })
                    .catch(e => {
                        if (e.response?.status < 404) {
                            handleError(e)
                        } else {
                            console.error(e)

                        }
                    });
                const foundIndex = this.charges.findIndex((otherCharge) => otherCharge.Id == chg.Id);
                if (foundIndex != -1) {
                    this.charges.splice(foundIndex, 1);
                }
            }
            if (this.charges.length == 0) {
                this.$emit('mount')

            }
            // this.$emit('mount')
        },
        // async wobbleCharge(charge, direction) {
        //     console.log(charge.WobbleDirection, direction)
        //     const foundWobbleBuddy = await axios.post(
        //         process.env.VUE_APP_ENDPOINT + "/api/crimes/wobble",
        //         {
        //             CrimeId: charge.CrimeId,
        //             wobbleDirection: direction,
        //         },
        //         {
        //             headers: { Authorization: `Bearer ` + localStorage.getItem("user_token") },
        //         }
        //     ).then(result => result.data).catch(e => console.error(e));
        //     console.log(foundWobbleBuddy);
        // },
        validateSelectedTerm(charge) {
            let triad = charge.newExposureObject?.formattedTriad;
            let good = true;
            let formattedTriad = this.formatFormattedTriad(charge);
            // console.log(formattedTriad)
            if (formattedTriad?.length == 1) {
                // this.showErrorMessage('Select a term to add to the exposure')
                good = false;
            } else if (
                (triad[this.selectedTerm - 1]?.length == 0 &&
                    !charge.newExposureObject?.specialIndeterminate
                ) ||
                charge.CrimeSeverityId !== 3
            ) {
                good = false;
            } else if (charge.newExposureObject?.specialIndeterminate && this.selectedTerm == 2) {
                good = false;
            };
            return good;
        },
        showSectionNumber(charge) {
            let str = ``;
            if (charge?.CrimeState == 'Attempt') {
                str += 'PC 664/'
            } else if (charge?.CrimeState == 'Conspiracy') {
                str += 'PC 182/'
            }
            str += `${charge?.SectionNumber}`
            return str
        },
        formatFormattedTriad(chg) {
            const triad = chg?.newExposureObject?.formattedTriad;
            if (!triad) return [];
            let betterTriad = [];
            if (chg?.CrimeSeverityId == 1) {
                betterTriad.push('');
            } else if (chg?.newExposureObject?.specialIndeterminate) {
                betterTriad.push('LWOP');
                betterTriad.push('')
                betterTriad.push('DEATH');
            }
            // else if (chg.newExposureObject?.dotsonOptions?.length > 0) {
            //     betterTriad.push(chg.newExposureObject?.dotsonOptions[0]);
            //     betterTriad.push(chg.newExposureObject?.dotsonOptions[1]);
            //     betterTriad.push(chg.newExposureObject?.dotsonOptions[2]);

            // } 
            else if (triad[0] == triad[2]) {
                if (triad[1] == triad[2]) {
                    betterTriad.push(triad[2]);
                } else {
                    betterTriad.push(triad[2]);
                }
            } else if (triad[0] != triad[1] && triad[1] != triad[2]) {
                betterTriad.push(triad[0]);
                betterTriad.push(triad[1]);
                betterTriad.push(triad[2]);
            } else if (triad[0]?.length == 0 && triad[1]?.length == 0 && triad[2]?.length > 0) {
                betterTriad.push(triad[2]);
            } else {
                betterTriad.push(triad[0]);
                betterTriad.push(triad[1]);
                betterTriad.push(triad[2]);
            }

            // console.log(betterTriad)
            return betterTriad;
        },
        displayFormattedSentence(chg) {
            return SC.displayFormattedSentence(chg);
        },
        async updateCharge(chg, field) {
            // console.log(chg.CountNumber)
            const postedChg = await SC.postChargeField(
                localStorage.getItem("user_token"),
                chg.Id,
                "CountNumber",
                chg.CountNumber
            );
        },
        showErrorMessage(message) {
            this.errorMessage = message;
            setTimeout(() => {
                this.errorMessage = null;
            }, 3000);
        },
        changeSelectedChargesCountNumbers(up) {
            // up is a boolean
            let selectedCrimes = this.selectedCharges.filter(chg => chg.CrimeTypeId == 5);
            let selectedEnhancements = this.selectedCharges.filter(chg => chg.CrimeTypeId == 6 || chg.CrimeTypeId == 2);
            // console.log(selectedCrimes.map(chg => chg.CountNumber))
            // console.log(selectedEnhancements.map(chg => chg.CountNumber))
            if (up) {
                for (let i = selectedCrimes.length - 1; i >= 0; i--) {

                    let chg = selectedCrimes[i];
                    // if (chg.CrimeTypeId == 5) {
                    // console.log(chg.CountNumber)
                    let newCount = chg.CountNumber + 1;
                    let foundIndex = this.charges.findIndex((otherCharge) => otherCharge.CountNumber == newCount && otherCharge.CrimeTypeId == 5);
                    if (foundIndex == -1) {
                        // let foundInActualArray = this.selectedCharges.findIndex((otherCharge) => otherCharge.Id == chg.Id);
                        selectedCrimes[i].CountNumber = newCount;
                        this.updateCharge(selectedCrimes[i], 'CountNumber');
                    } else {
                        this.showErrorMessage('Count Number already occupied by another crime');
                    };
                    // } else if (chg.CrimeTypeId == 6 || chg.CrimeTypeId == 2 || chg.CrimeTypeId == 3) {
                    //     let newCount = chg.CountNumber + 1;
                    //     let foundIndex = this.charges.findIndex((otherCharge) => otherCharge.CountNumber == newCount && otherCharge.CrimeTypeId == 5);
                    //     if (foundIndex != -1) {
                    //         this.selectedCharges[i].CountNumber = newCount;
                    //     };
                    // }
                }
                for (let i = selectedEnhancements.length - 1; i >= 0; i--) {
                    let chg = selectedEnhancements[i];
                    // console.log(chg.CountNumber)
                    let newCount = chg.CountNumber + 1;
                    let foundIndex = this.charges.findIndex((otherCharge) => otherCharge.CountNumber == newCount && otherCharge.CrimeTypeId == 5);
                    if (foundIndex != 1) {
                        // console.log('enh ' + chg.CountNumber + ' -> ' + newCount)
                        chg.CountNumber = newCount;
                        this.updateCharge(chg, 'CountNumber');
                    } else {

                        // console.log('bad enh ' + chg.CountNumber + ' -> ' + newCount)
                        this.showErrorMessage(`No Crime with count number ${newCount} available`);
                    };
                }
            } else {
                for (let i = 0; i < selectedCrimes.length; i++) {
                    let chg = selectedCrimes[i];
                    // console.log(chg.CountNumber)
                    let newCount = chg.CountNumber - 1;
                    let foundIndex = this.charges.findIndex((otherCharge) => otherCharge.CountNumber == newCount && otherCharge.CrimeTypeId == 5);
                    if (foundIndex == -1 && newCount > 0) {
                        // console.log('crm ' + chg.CountNumber + ' -> ' + newCount)
                        chg.CountNumber = newCount;
                        this.updateCharge(chg, 'CountNumber');
                    } else {
                        this.showErrorMessage('Count Number already occupied by another crime');
                    };
                };
                for (let i = 0; i < selectedEnhancements.length; i++) {
                    let chg = selectedEnhancements[i];
                    // console.log(chg.CountNumber)
                    let newCount = chg.CountNumber - 1;
                    let foundIndex = this.charges.findIndex((otherCharge) => otherCharge.CountNumber == newCount && otherCharge.CrimeTypeId == 5);
                    if (foundIndex != -1 && newCount > 0) {
                        // console.log('enh ' + chg.CountNumber + ' -> ' + newCount)
                        chg.CountNumber = newCount;
                        this.updateCharge(chg, 'CountNumber');
                    } else {

                        // console.log('bad enh ' + chg.CountNumber + ' -> ' + newCount)

                        this.showErrorMessage(`No Crime with count number ${newCount} available`);
                    };
                }
            };
            this.$emit('onCalc')
        }
    },
    mounted() {
        // if (this.charges?.length > 0) {
        //     this.numberOfStrikes = this.charges[this.charges.length - 1]?.NumberOfStrikes
        // }

    },
};
</script>
<style scoped></style>